import { Heading, Text } from '@sparemin/blockhead';
import React from 'react';
import { useSelector } from 'react-redux';
import { hasRestoreEmbedVideoAccessSelector } from 'redux/modules/pricing';

export interface ArchivedVideoSectionContentsProps {}

const ArchivedVideoSectionContents: React.FC<ArchivedVideoSectionContentsProps> = () => {
  const hasRestoreEmbedVideoAccess = useSelector(
    hasRestoreEmbedVideoAccessSelector,
  );

  return (
    <>
      <Heading level={1}>This video was archived</Heading>

      <Text variant="p" weight="normal">
        {!hasRestoreEmbedVideoAccess
          ? 'All videos older than 6 months are archived. Archived videos can be restored on our Pro plan.'
          : 'All videos older than 6 months are archived. You can restore it to regain access for 30 days.'}
      </Text>
    </>
  );
};

export default ArchivedVideoSectionContents;
